import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 2v3H4V5h16zM4 21V10h16v11H4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 5.01h16V8H4z",
  opacity: ".3"
})), 'CalendarTodayTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CalendarTodayTwoTone.js
// module id = 2582
// module chunks = 2